import React, { useMemo } from "react";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { dateStringToStandardFormat } from "@/utils/dateFormatter";
import { formatDistance } from "@/utils/utils";
import MoreMenu from "@/components/MoreMenu";

const useNissanPricingTableColumns = ({ onMenuItemClick }) =>
  useMemo(
    () => [
      {
        title: "Origin City",
        dataIndex: "originCity",
        render: text => <span className="span-click">{text}</span>,
      },
      {
        title: "Origin State",
        dataIndex: "originState",
        render: text => <span className="span-click">{text}</span>,
      },
      {
        title: "Destination City",
        dataIndex: "destinationCity",
        render: text => <span className="span-click">{text}</span>,
      },
      {
        title: "Destination State",
        dataIndex: "destinationState",
        render: text => <span className="span-click">{text}</span>,
      },
      {
        title: "Miles",
        dataIndex: "miles",
        render: text => <span className="span-click">{formatDistance(text)}</span>,
      },
      {
        title: "Dealer Price (A-B-C)",
        dataIndex: "aDealerPrice",
        render: (_, record) => (
          <span className="span-click">
            {record.aDealerPrice}-{record.bDealerPrice}-{record.cDealerPrice}
          </span>
        ),
      },
      {
        title: "Transporter Price (A-B-C)",
        dataIndex: "aTransporterPrice",
        render: (_, record) => (
          <span className="span-click">
            {record.aTransporterPrice}-{record.bTransporterPrice}-{record.cTransporterPrice}
          </span>
        ),
      },
      {
        title: "Created At",
        dataIndex: "creationTime",
        render: text => <span className="span-click">{dateStringToStandardFormat(text, { showTime: true })}</span>,
      },
      {
        title: "",
        dataIndex: "moreMenu",
        render: (_, record) => (
          <span>
            <MoreMenu
              onItemClick={key => onMenuItemClick(key, record)}
              items={[
                {
                  key: "delete",
                  icon: <DeleteOutlined />,
                  label: "Delete",
                  authority: "NissanService.Prices.Delete",
                },
                {
                  key: "edit",
                  icon: <EditOutlined />,
                  label: "Edit",
                  authority: "NissanService.Prices.Edit",
                },
              ]}
            />
          </span>
        ),
      },
    ],
    [onMenuItemClick],
  );

export default useNissanPricingTableColumns;
